<template>
  <div class="resource-wrap">
    <a class="resource"
     :disabled="fileDownloading"
      href="javascript:void(0)"
      @click="$emit('click')"
    >
      <div class="file-type">
        <report-icon/>
        <span class="filename">
          {{ truncateFileName ? ellipse(fileName) : fileName }}
        </span>
      </div>
      <div
        class="async"
        v-if="fileDownloading"
      >
        <async-loader/>
      </div>
      <div
        v-else
        class="download btn-svg">
        <download-icon/>
      </div>
    </a>
  </div>
</template>

<script>
  import ellipse from '@mixins/ellipse'
  import ReportIcon from '@atoms/ReportIcon.vue'
  import DownloadIcon from '@atoms/DownloadIcon.vue'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    props: {
      fileName: String,
      fileDownloading: {
        type: Boolean,
        default: false
      },
      truncateFileName: {
        type: Boolean,
        default: true
      }
    },
    mixins: [ellipse],
    components: {
      DownloadIcon,
      ReportIcon,
      AsyncLoader
    }
  }
</script>
